import React from 'react';
import { Grid, TextField } from '@material-ui/core';

export default function ProcessorOAuthCredentials({ processorSettings, setProcessorSettings }) {
    return (
        <>
            <Grid item xs={12}>
                <TextField
                    fullWidth
                    id="connector-client-id"
                    label="Client ID"
                    variant="outlined"
                    value={processorSettings.clientId ?? ''}
                    onChange={(e) => setProcessorSettings(prev => ({ ...prev, clientId: e.target.value }))}
                />
            </Grid>
            <Grid item xs={12}>
                <TextField
                    fullWidth
                    id="connector-client-secret"
                    label="Client secret"
                    variant="outlined"
                    value={processorSettings.clientSecret ?? ''}
                    onChange={(e) => setProcessorSettings(prev => ({ ...prev, clientSecret: e.target.value }))}
                />
            </Grid>
        </>
    );
}
